// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"Hero-module--videoContainer--3XJYL","opacity":"Hero-module--opacity--1reaK"};